export enum SyncStatus {
    Connected = "Connected",
    Disconnected = "Disconnected",
    Reconnecting = "Reconnecting"
}
